"use client";

import { Core } from "@faire/slate/foundation/color";
import { iconCls } from "@faire/slate/lib/tracking";
import { createSVGIconV2 } from "@faire/web/slate/icons/lib/createSVGIconV2";
import React from "react";

// Implemented using the icons from here: https://faire-wholesale.slack.com/archives/C08PZGMUC3Z/p1756238353493689?thread_ts=1756237700.863289&cid=C08PZGMUC3Z
export const NotificationBell = createSVGIconV2(
  <>
    <path
      d="M12 2C13.8642 2 15.6818 2.78336 17 4.15107C18.3182 5.51878 19.179 7.37379 19.179 9.30803C19.179 17.4171 21.2299 17.634 22 17.634H2C2.78646 17.634 5.121 17.4001 5.121 9.30803C5.121 7.37379 5.68181 5.51878 7 4.15107C8.31819 2.78336 10.1358 2 12 2Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 20C14 21.1046 13.1046 22 12 22C10.8954 22 10 21.1046 10 20"
      stroke="currentColor"
      strokeLinecap="round"
    />
  </>,
  "NotificationBell",
  (strictLocalize) => ({
    color: Core.icon.primary,
    fill: "none",
    titleAccess: strictLocalize({
      id: "u3K8H2",
      defaultMessage: "Notification",
      description: {
        text: "Message for screenreaders when only the icon is displayed",
      },
    }),
    viewBox: "0 0 24 24",
    className: iconCls(),
  })
);
